import { mapState, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';

export const serviceComputed = {
	...mapState('userGroupControlManagementStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('userGroupControlManagementStore', Object.keys(actions)),
	...mapMutations('userGroupControlManagementStore', Object.keys(mutations))
};
